import React, { useState } from "react"
import "./ChooseSlotForm.scss"
import SearchInput from "../SearchInput/SearchInput"
import { Button } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { useSlots } from "../../hooks/useSlots"

const tNamespace = "knowledgeBase:slot."

export interface ChooseSlotFormProps {
    onCreate?: () => void
    onSelect: (slotId: string, slotTitle: string) => void
    excludeSlotIds?: string[]
}

const ChooseSlotForm: React.FC<ChooseSlotFormProps> = props => {
    const { t } = useTranslation()
    const { onCreate, onSelect, excludeSlotIds } = props
    const { slots } = useSlots()

    const [query, setQuery] = useState("")
    const handleSearchChange = (searchValue: string) => setQuery(searchValue.toLowerCase())

    const availableSlots = excludeSlotIds?.length ? slots.filter(s => !excludeSlotIds.includes(s.ExternalId)) : slots

    const filteredSlots = query
        ? availableSlots.filter(s => s.Title.toLowerCase().includes(query) || s.Id.toLowerCase().includes(query))
        : availableSlots

    return (
        <div className="choose-slot-form">
            {onCreate && (
                <Button onClick={onCreate} variant="light" className="choose-slot-form__create-btn">
                    {t(`${tNamespace}create-new-slot`)}
                </Button>
            )}
            <SearchInput onChange={handleSearchChange} className="choose-slot-form__search" />
            <div className="choose-slot-form__content">
                {filteredSlots.map(slot => (
                    <div
                        key={slot.Id}
                        className="choose-slot-form__item"
                        onClick={() => onSelect(slot.ExternalId, slot.Title)}
                    >
                        {slot.Title || `{{ ${slot.ExternalId} }}`}
                    </div>
                ))}
            </div>
        </div>
    )
}

export default ChooseSlotForm
